// extracted by mini-css-extract-plugin
module.exports = {"menu-item":"style_menu-item__3eEJT","open":"style_open__3oJn2","font-color-red":"style_font-color-red__2pYmq","child-menu":"style_child-menu__3PshZ"};